import { render, staticRenderFns } from "./RtcPrivateVideo.vue?vue&type=template&id=75164d8e&scoped=true"
import script from "./RtcPrivateVideo.vue?vue&type=script&lang=js"
export * from "./RtcPrivateVideo.vue?vue&type=script&lang=js"
import style0 from "./RtcPrivateVideo.vue?vue&type=style&index=0&id=75164d8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75164d8e",
  null
  
)

export default component.exports